import { useEffect } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { FUNDS_HISTORY_PAGE_SIZE } from '../../UnappliedFunds.constants';

export const useFundsHistoryFilters = () => {
  const { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(FUNDS_HISTORY_PAGE_SIZE);

  useEffect(() => {
    setPage(1);
  }, [setPage, currentSearch]);

  return { page, setPage, perPage, setPerPage, searchString, setSearchString, currentSearch };
};
